import { H1, H2, H3, P2 } from '../../../styles/FontStyles';
import { colors } from '../../../styles/GlobalStyles';
import { Main, Section3Boxes, Section3Wrapper } from '../Home.styled';

import img1 from '../../../assets/images/sec3Img1.png';
import img2 from '../../../assets/images/sec3Img2.png';
import img3 from '../../../assets/images/sec3Img3.png';
import img4 from '../../../assets/images/sec3Img4.png';
import { Div, Img } from '../../../styles/Styles';

export const Section3 = () => {
  return (
    <Section3Wrapper id='section4'>
      <H2 center mb='120' color={colors.white}>
        Why Choose Travelution?
      </H2>

      <Main>
        <Section3Boxes>
          <div>
            <Img src={img1} alt='Worldwide growing community' />
            <Div $flex $column>
              <H3 mb='16'>Worldwide growing community</H3>
              <P2>
                Be part of a vibrant, growing network of travelers and
                entrepreneurs who share exclusive experiences, insights, and
                opportunities worldwide.
              </P2>
            </Div>
          </div>
          <div>
            <img src={img2} alt='A one-stop shop for travel' />
            <Div $flex $column>
              <H3 mb='16'>A one-stop shop for travel</H3>
              <P2>
                You’ll never want to travel any other way. Perfect blend of
                technology with the joy of discovering new places, flavors,
                cultures, and building new friendships.
              </P2>
            </Div>
          </div>
          <div>
            <img src={img3} alt='EU-Compliant and Transparent' />
            <Div $flex $column>
              <H3 mb='16'>An Opportunity Worth Sharing</H3>
              <P2>
                Everyone loves Travel! If your friends had the chance to travel
                smarter, cheaper, and stress-free, would they take it?
                Absolutely! Make money while allowing them travel like you!
              </P2>
            </Div>
          </div>
          <div>
            <img src={img4} alt='Dedicated Support Team' />
            <Div $flex $column>
              <H3 mb='16'>Dedicated Support Team</H3>
              <P2>
                Our knowledgeable and friendly support team is here to help with
                any questions or concerns, ensuring a smooth and satisfying
                experience.
              </P2>
            </Div>
          </div>
        </Section3Boxes>
      </Main>
    </Section3Wrapper>
  );
};
